/* eslint-disable */
import { Col, Modal, Row, Tag } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'
import { JSXElementConstructor, Key, ReactElement, ReactFragment, ReactPortal,
  useState
} from 'react'

interface AuditLog {
  action: string;
  created_at: string;
  created_by: string;
  record_id: string | null;
}

interface RefundRequest {
  auditLogs: AuditLog[] | undefined;
  // Include other fields you might be using here
}

const ViewRefundRequest = () => {
  const navigate = useNavigate()
  const [isModalVisible, setIsModalVisible] = useState(false) // State to manage modal visibility
  const [isFooterVisible, setIsFooterVisible] = useState(false) // State to toggle div visibility
  const { state } = useLocation()
  const refundRequest = state || {}
  const toggleFooterDetails = () => {
    setIsFooterVisible(prevState => !prevState) // Toggle visibility
  }
  const toggleModalVisibility = () => {
    setIsModalVisible(!isModalVisible)
  }
  const bailiffRefundRequest = state || {}
  const formatDate = ({ dateString }: { dateString: any }) => {
    const date = new Date(dateString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`
  }
  return (
    <div className="w-full p-6 bg-gray-50">
      {/* Enhanced Custom CSS Styles */}
      <style>{
        `
        .enhanced-card {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
        }
        .enhanced-card:hover {
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          transform: translateY(-2px);
        }
        .enhanced-button {
          border-radius: 8px;
          font-weight: 600;
          transition: all 0.2s ease;
        }
        .enhanced-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        .section-header {
          background: linear-gradient(135deg, #37762f 0%, #4a7c59 100%);
          color: white;
          padding: 12px 16px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 16px;
        }
        `
      }</style>
      
      {/* Enhanced Breadcrumb Navigation */}
      <div className="px-5 py-4 border-b border-gray-300" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '0 0 12px 12px',
        marginBottom: '20px',
      }}>
        <div className="flex justify-between items-center">
          <div className="text-title font-semibold text-gray-800 flex items-center">
            <div style={{
              background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
              borderRadius: '50%',
              width: '40px',
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px',
              boxShadow: '0 4px 8px rgba(55, 118, 47, 0.3)',
            }}>
              <span style={{ fontSize: '18px' }}>⚖️</span>
            </div>
            <div>
              <span
                className="cursor-pointer text-blue-600 hover:text-blue-700 enhanced-button"
                style={{
                  background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
                  transition: 'all 0.2s ease',
                }}
                onClick={() => navigate('/refund-request-list')}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 4px 8px rgba(59, 130, 246, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 4px rgba(59, 130, 246, 0.3)';
                }}
              >
                <i className="material-icons align-middle mr-2"></i>Bailiff Refund Request
              </span>
              {' > '}
              <span className="font-medium text-gray-600">{refundRequest?.beneficiary_account_name}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Button to toggle logs */}
      <div className="px-7 py-4">
        <div
          className="cursor-pointer enhanced-button text-white px-6 py-3 rounded-full transition-all duration-300"
          style={{
            background: isModalVisible 
              ? 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)'
              : 'linear-gradient(135deg, #6b8e3d 0%, #4a7c59 100%)',
            boxShadow: '0 4px 12px rgba(55, 118, 47, 0.3)',
            transform: isModalVisible ? 'scale(1.05)' : 'scale(1)',
          }}
          onClick={toggleModalVisibility}
          onMouseEnter={(e) => {
            if (!isModalVisible) {
              e.currentTarget.style.transform = 'translateY(-2px) scale(1.02)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(55, 118, 47, 0.4)';
            }
          }}
          onMouseLeave={(e) => {
            if (!isModalVisible) {
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(55, 118, 47, 0.3)';
            }
          }}
        >
          {isModalVisible ? '🔒 Close Logs' : '📋 Show Logs'}
        </div>
      </div>

      {/* Beneficiary Refund Request Details Section */}
      <div className="px-7 py-4 mt-4 enhanced-card" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.2s ease',
      }}>
        <div className="section-header">
          <span style={{ fontSize: '18px' }}>💰</span>
          Beneficiary Refund Request Details
        </div>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Beneficiary Account Name</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.beneficiary_account_name}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Beneficiary Bank Name</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.beneficiary_bank_name}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Beneficiary Account Number</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.beneficiary_account_number}</div>
          </Col>
        </Row>

        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Debit Account Number</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.debit_account_number}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Debit Account Name</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.debit_account_name}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Transaction Reference</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.transaction_reference}</div>
          </Col>
        </Row>

        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Amount to be Refunded</div>
            <div className="text-base font-medium text-gray-500">
              {parseInt(String(refundRequest?.amount)).toLocaleString()}
            </div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Transaction Currency</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.transaction_currency}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Reason</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.reason}</div>
          </Col>
        </Row>

        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Status</div>
            <div className="text-base font-medium text-gray-500">
              {(() => {
                const status = String(refundRequest?.status ?? '').trim();
                let displayStatus = status || 'PENDING';
                let color = 'default';

                if (displayStatus === 'PENDING') {
                  displayStatus = 'Pending Refund';
                  color = 'warning';
                } else if (displayStatus === 'INITIATED') {
                  displayStatus = 'Initiated Refund';
                  color = 'processing';
                } else if (displayStatus === 'COMPLETED' || displayStatus === 'APPROVED' || displayStatus === 'Downloaded to be Refunded') {
                  displayStatus = 'Completed Refund';
                  color = 'success';
                } else if (displayStatus === 'RECEIVED REQUEST') {
                  displayStatus = 'Received Request';
                  color = 'processing';
                } else if (displayStatus === 'REJECTED') {
                  displayStatus = 'Rejected';
                  color = 'error';
                }

                return (
                  <Tag color={color} style={{ borderRadius: 999, padding: '2px 10px', fontWeight: 600 }}>
                    {displayStatus}
                  </Tag>
                );
              })()}
            </div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Requested Date</div>
            <div className="text-base font-medium text-gray-500">{formatDate({ dateString: refundRequest?.created_at })}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Updated Date</div>
            <div className="text-base font-medium text-gray-500">{formatDate({ dateString: refundRequest?.updated_at })}</div>
          </Col>
        </Row>
      </div>

      {/* Bidder Refund Request Details Section */}
      <div className="px-7 py-4 mt-6 enhanced-card" style={{
        background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
        borderRadius: '12px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.2s ease',
      }}>
        <div className="section-header">
          <span style={{ fontSize: '18px' }}>👤</span>
          Bidder Refund Request Details
        </div>
        <Row gutter={[16, 16]}>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Bidder Name</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.bidders.full_name}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Bidder ID</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.bidders.nid}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Bidder Phone Number</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.bidders.phone_number}</div>
          </Col>
        </Row>

        <Row gutter={[16, 16]} className="pt-4">
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Bidder Email</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.bidders.email}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Reference Number</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.bid_securities.ref_number}</div>
          </Col>
          <Col xs={24} xl={8}>
            <div className="font-semibold text-gray-700">Amount Paid for Bid Security</div>
            <div className="text-base font-medium text-gray-500">{refundRequest?.bid_securities.amount_covered}</div>
          </Col>
        </Row>
      </div>

      {/* Enhanced Modal for Logs */}
      <Modal
        visible={isModalVisible}
        onCancel={toggleModalVisibility}
        footer={null}
        width="70%"
        className="enhanced-modal"
        centered
        style={{
          borderRadius: '12px',
          overflow: 'hidden',
        }}
        title={
          <div style={{
            background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
            color: 'white',
            padding: '16px 20px',
            borderRadius: '12px 12px 0 0',
            fontSize: '18px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            margin: '-24px -24px 0 -24px',
          }}>
            <span style={{ fontSize: '20px' }}>📋</span>
            Bailiff Refund Request Logs
          </div>
        }
      >
        <div className="enhanced-card p-6" style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
          borderRadius: '12px',
          border: '1px solid #e5e7eb',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
          margin: '0 -12px',
        }}>
          <div className="section-header" style={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
            color: 'white',
            padding: '12px 16px',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '20px',
          }}>
            <span style={{ fontSize: '18px' }}>📝</span>
            Audit Logs
          </div>

          {/* Enhanced audit logs */}
          <div style={{
            maxHeight: '400px',
            overflowY: 'auto',
            paddingRight: '8px',
          }}>
            {refundRequest?.auditLogs?.map((log: {
              action: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined;
              created_by: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | ReactFragment | ReactPortal | null | undefined;
              created_at: any;
              record_id: any;
            }, index: Key | null | undefined) => (
              <div key={index} className="enhanced-card mb-4 p-4" style={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
                transition: 'all 0.2s ease',
              }}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} xl={6}>
                    <div className="font-semibold text-gray-700 mb-2">Action</div>
                    <div className="text-base font-medium text-gray-500 p-2 bg-gray-50 rounded">{log?.action}</div>
                  </Col>
                  <Col xs={24} xl={6}>
                    <div className="font-semibold text-gray-700 mb-2">Created By</div>
                    <div className="text-base font-medium text-gray-500 p-2 bg-gray-50 rounded">{log?.created_by}</div>
                  </Col>
                  <Col xs={24} xl={6}>
                    <div className="font-semibold text-gray-700 mb-2">Created At</div>
                    <div className="text-base font-medium text-gray-500 p-2 bg-gray-50 rounded">{formatDate({ dateString: log?.created_at })}</div>
                  </Col>
                  <Col xs={24} xl={6}>
                    <div className="font-semibold text-gray-700 mb-2">Record ID</div>
                    <div className="text-base font-medium text-gray-500 p-2 bg-gray-50 rounded">{log?.record_id ?? 'N/A'}</div>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ViewRefundRequest
